import React, {useEffect, useState} from 'react';
import cl from './PollQuestionList.module.css';
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faPlus, faTrashCanArrowUp} from "@fortawesome/free-solid-svg-icons";
import useIsFirstRender from "../../../../../../hooks/useIsFirstRender";
import Dialog from "../../../../../ui/components/Dialog/Dialog";
import PollQuestionForm from "./PollQuestionForm/PollQuestionForm";
import {getPollTypeName} from "./utils";

const PollQuestionList = ({
                              items,
                              disabled,
                              change
                          }) => {
    const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
    const [editPollQuestion, setEditPollQuestion] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [questions, setQuestions] = useState(null);
    const isFirstRender = useIsFirstRender();
    const {t} = useTranslation();

    useEffect(() => {
        if (questions === null || (Array.isArray(questions) && questions.length <= 0)) {
            setIsLoading(prev => !prev);

            setQuestions(items);

            setIsLoading(prev => !prev);
        }
    }, [items]);

    useEffect(() => {
        if (change && !disabled && !isFirstRender) {
            change(questions);
        }
    }, [questions]);

    const addItem = () => {
        if (questions !== null && Array.isArray(questions) && questions.length >= 10)
            return;

        if (!disabled && !isLoading) {
            const itemToAdd = {
                id: null,
                point: questions === null || questions.length <= 0
                    ? 1
                    : Math.max(...questions.map(item => item.point)) + 1,
                questionText: '',
                multipleSelection: false,
                isRequired: false,
                pollId: null,
                parentQuestionId: null,
                pollQuestions: null
            };

            setQuestions(questions === null || !Array.isArray(questions)
                ? [itemToAdd]
                : [...questions, itemToAdd]);
        }
    };

    const removeItem = (point) => {
        if (!disabled && !isLoading) {
            let data = [...questions.filter(item => item.point !== point)];
            for (const [i, value] of data.entries()) {
                value.point = i + 1;
            }

            setQuestions(data);
        }
    };

    const editItem = (question) => {
        if (!disabled && !isLoading && question !== null) {
            setEditPollQuestion(question);

            setIsEditDialogOpen(prev => !prev);
        }
    };

    const onSave = (item) => {
        if (item) {
            setQuestions([
                ...questions.filter(p => p.point !== item.point),
                item
            ]);

            setIsEditDialogOpen(prev => !prev);
        }
    };

    return (
        <>
            {editPollQuestion !== null
                ? <Dialog open={isEditDialogOpen}
                          usePortalToDocumentBody={true}
                          width='900px'
                          height='600px'>
                    <PollQuestionForm question={editPollQuestion}
                                      close={() => setIsEditDialogOpen(prev => !prev)}
                                      onSave={onSave}/>
                </Dialog>
                : null}
            <div className={cl.pollQuestionListContainer}>
                <div className={cl.toolbarContainer}>
                    <button className={cl.toolbarBtn}
                            onClick={addItem}
                            disabled={disabled || isLoading || (questions !== null && Array.isArray(questions) && questions.length >= 10)}
                            type={'button'}>
                    <span>
                        <FontAwesomeIcon icon={faPlus}/>
                    </span>
                        <span>
                        {t("poll.form.add-question-btn")}
                    </span>
                    </button>
                </div>
                <div className={cl.tableHeaderContainer}>
                    <div style={{width: '130px'}}>
                        {t("poll.form.question-order")}
                    </div>
                    <div style={{width: '150px'}}>
                        {t("poll.form.type")}
                    </div>
                    <div style={{width: 'calc(100% - 380px)'}}>
                        {t("poll.form.point-question")}
                    </div>
                    <div style={{width: '50px'}}>

                    </div>
                    <div style={{width: '50px'}}>

                    </div>
                </div>
                <div>
                    {isLoading
                        ? <div className={cl.loaderContainer}>
                            <div className='loader'></div>
                        </div>
                        : null
                    }
                    {questions !== null && questions.length > 0
                        ? <table className={cl.table}>
                            <tbody>
                            {questions.sort((first, second) => first.point - second.point).map(p => {
                                return (
                                    <tr key={p.point}>
                                        <td style={{width: '130px'}}>
                                            {p.point}
                                        </td>
                                        <td style={{width: '150px'}}>
                                            {getPollTypeName(t, p.type)}
                                        </td>
                                        <td style={{width: 'calc(100% - 380px)'}}>
                                            {p.questionText !== null
                                                ? p.questionText
                                                : null
                                            }
                                        </td>
                                        <td style={{width: '50px'}}>
                                            <FontAwesomeIcon className={cl.edit} onClick={() => editItem(p)}
                                                             icon={faEdit}/>
                                        </td>
                                        <td style={{width: '50px'}}>
                                            <FontAwesomeIcon className={cl.reset} onClick={() => removeItem(p.point)}
                                                             icon={faTrashCanArrowUp}/>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                        : null
                    }
                </div>
            </div>
        </>
    );
};

export default PollQuestionList;